module.exports = __webpack_public_path__ + "images/mdj/common/common_icon_waww-681e8c4f3f724edfed1f4e72d4e75725.png";